import ApprovedIcon from 'assets/icons/check.svg';
import CanceledIcon from 'assets/icons/close.svg';

import { DealItem, DealLineItemData } from 'components/common/types/DealItem';
import Chip, { Color as ChipColor } from 'lib/Chip';
import SvgIcon from 'lib/SvgIcon';

const ServiceLineChip = ({
  variant,
  numberOfServices,
}: {
  variant: 'approved' | 'cancelled';
  numberOfServices: number;
}): React.ReactElement => {
  if (variant === 'approved') {
    return (
      <div className="flex items-center gap-0.5 text-green-700 bg-green-50 px-1.5 py-0.5 rounded-full">
        <SvgIcon src={ApprovedIcon} className="!text-green-700" />
        <span>{numberOfServices}</span>
      </div>
    );
  }

  return (
    <div className="flex items-center gap-0.5 text-pinkRed-700 bg-pinkRed-50 px-1.5 py-0.5 rounded-full">
      <SvgIcon src={CanceledIcon} className="!text-pinkRed-700" />
      <span>{numberOfServices}</span>
    </div>
  );
};

const ServicesLineRenderer = ({ line }: { line: DealLineItemData }): React.ReactElement => {
  if (!line.approvedServicesCount && !line.cancelledServicesCount) return <span>-</span>;

  return (
    <div className="flex justify-around py-1.5 px-2 border border-dashed border-neutral-950-opacity-10 rounded-xl gap-2">
      {!!line.approvedServicesCount && (
        <ServiceLineChip variant="approved" numberOfServices={line.approvedServicesCount} />
      )}
      {!!line.cancelledServicesCount && (
        <ServiceLineChip variant="cancelled" numberOfServices={line.cancelledServicesCount} />
      )}
    </div>
  );
};

const ServicesCampaignRenderer = ({ data }: DealItem): React.ReactElement => {
  if (!data?.approvedServicesCount && !data?.pendingServicesCount) return <span>-</span>;
  if (!data?.approvedServicesCount)
    return <Chip color={ChipColor.YELLOW} label={`${data?.pendingServicesCount} pending`} />;
  return <Chip color={ChipColor.PRIMARY} label={`${data?.approvedServicesCount} approved`} />;
};

const ServicesRenderer = ({ data }: DealItem): React.ReactElement => {
  if (data?.isChildRow) return <ServicesLineRenderer line={data as DealLineItemData} />;
  return <ServicesCampaignRenderer data={data} />;
};

export default ServicesRenderer;
